import { FilterValues } from '../models/filter.interface';

/**
 * Подсчитывает количество активных фильтров
 */
export function countActiveFilters(
  currentFilters: FilterValues,
): number {
  const groupingFormKey = 'group_by';

  return Object.keys(currentFilters).filter((key) => {
    if (key === groupingFormKey) {
      return false;
    }

    const currentValue = currentFilters[key];

    if (
      currentValue === null ||
      currentValue === undefined ||
      currentValue === ''
    ) {
      return false;
    }

    if (Array.isArray(currentValue) && currentValue.length === 0) {
      return false;
    }
    return true;
  }).length;
}
